<template>
    <v-container>
        <v-card class="mb-5" :loading="verify_loading" v-if="!auth.user.email_verified_at || verify_msg">
            <v-card-title>Verification</v-card-title>
            <v-card-text v-if="verify_msg"><v-alert :type="verify_msg_type">{{ verify_msg }}</v-alert></v-card-text>
            <v-card-text  v-if="!auth.user.email_verified_at">You need to verify your email before getting a ticket to one of our free events. Please check your email and spam folder and click the verify link.</v-card-text>
            <v-card-actions v-if="!auth.user.email_verified_at"><v-btn primary @click="resendVerification">Resend Email</v-btn></v-card-actions>
        </v-card>
        <v-card>
            <v-card-title>Personal Information</v-card-title>
            
            <v-card-text>
                <v-form ref="editprofile" lazy-validation class="bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="saveProfile" >
                    <v-container>
                        <v-row>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                >
                                <v-text-field validate-on-blur v-model="editPersonalInfo.first_name" label="First Name" type="text" required="true"></v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                >
                                <v-text-field validate-on-blur v-model="editPersonalInfo.last_name" label="Last Name" type="text" required="true"></v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                >
                                <v-text-field validate-on-blur v-model="editPersonalInfo.phone" label="Phone" type="text" placeholder="+353 1234 56789"></v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                >
                                <v-select :items="['<30','31-45','45-65','65+']" validate-on-blur v-model="editPersonalInfo.age" label="Age" type="text"></v-select>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                >
                                <strong>I am</strong>
                                <v-checkbox
                                    v-model="editPersonalInfo.return_to_work"
                                    label="returning to work"
                                    ></v-checkbox>
                                <v-checkbox
                                v-model="editPersonalInfo.return_to_education"
                                label="returning to education"
                                ></v-checkbox>
                                <v-checkbox
                                v-model="editPersonalInfo.return_to_unsure"
                                label="unsure"
                                ></v-checkbox>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                >
                                <v-select :items="genderOptions" validate-on-blur v-model="editPersonalInfo.gender" label="Gender"></v-select>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                >
                                <v-select multiple chips :items="contractOptions" validate-on-blur v-model="editPersonalInfo.contract_types" label="Roles I'm interested in"></v-select>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                >
                                <v-select multiple chips :items="categories" validate-on-blur v-model="editPersonalInfo.industry_experience" label="Industries I've worked in" item-text="title" item-value="id"></v-select>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                >
                                <v-select multiple chips :items="categories" validate-on-blur v-model="editPersonalInfo.industry_goals" label="Industries I'd like to work in" item-text="title" item-value="id"></v-select>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                class="text-center"
                                >
                                <v-btn :loading="editPersonalInfo.processing" class="btn-indigo ml-auto" color="primary" type="submit">Save Changes
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>

            </v-card-text>
        </v-card>
        <UserFiles  :baseurl="baseurl" :selectable="false" v-if="auth.user && isUser()"></UserFiles>
        <v-card class="mt-5">
            <v-card-title>Update Email Address</v-card-title>
            <v-card-text>
                <v-form ref="updateEmailForm" lazy-validation class="bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="saveEmail" >
                    <v-container>
                        <v-row>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                >
                                <v-text-field validate-on-blur :error-messages="updateEmailErrors.email" :rules="emailRules" v-model="updateEmailForm.email" label="New Email" type="text" required="true"></v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                class="text-center"
                                >
                                <v-btn :loading="updateEmailForm.processing" class="btn-indigo ml-auto" color="primary" type="submit">Update Email
                                </v-btn>
                            </v-col>    
                        </v-row>
                    </v-container> 
                </v-form> 
            </v-card-text>
        </v-card>
        <v-card class="mt-5">
            <v-card-title>Change Password</v-card-title>
            <v-card-text>
                <v-form ref="updatepassword" lazy-validation class="bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="savePassword" >
                    <v-container>
                        <v-row>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                >
                                <v-text-field validate-on-blur :rules="passwordRules" :error-messages="updatePasswordErrors.updatepassword" v-model="updatePasswordForm.updatepassword" label="New Password" type="password" required="true"></v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                class="text-center"
                                >
                                <v-btn :loading="updatePasswordForm.processing" class="btn-indigo ml-auto" color="primary" type="submit">Update Password
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>  
                </v-form>
            </v-card-text>
        </v-card>

        <v-card class="mt-5">
            <v-card-title>Delete your account</v-card-title>
            <v-card-text>
                <p>We'll be sorry to see you go, but if you would like to delete your account and remove your personal details and uploaded data, use the button below. </p>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="deletedialog=true">Delete my Account</v-btn>
            </v-card-actions>
        </v-card>
        <v-dialog v-model="deletedialog" style="max-width:600px">
            <v-card>
                <v-card-title>
                    Are you sure you would like to delete your account?
                </v-card-title>
                <v-card-text>
                    We'll miss you! BacktoWorkConnect does not sell or share your data with anyone. This action is permanent and unrecoverable.
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="deleteUser">Confirm Deletion</v-btn>
                    <v-btn color="primary" @click="deletedialog=false">Cancel and Return</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import UserFiles from '@/Shared/UserFiles'
import axios from 'axios'

export default {
  props: {
    auth: Object,
    loading: Boolean,
    errors: Object,
    state: String,
    baseurl: String,
    prevurl: String,
    usermeta: Array,
    categories: Array,
    
  },
  components: {
    UserFiles,
  },
  data() {
    return {
        deletedialog:false,
        verify_msg_type: "",
        verify_loading:false,
        verify_msg: "",
        genderOptions: ['Male','Female','Other','Prefer not to say'],
        contractOptions: ['Full-time','Part-time','Returnships','Volunteer','Flexible','Remote','Contract'],
        editPersonalInfoErrors: {
          first_name: null,
          last_name: null,
          gender: null,
          return_to_work: false,
          return_to_education: false,
          return_to_unsure: false,
          phone: null,
          age: null,
          contract_types: null,
          industry_goals: null,
          industry_experience: null
        },
        editPersonalInfo: this.$inertia.form({
            first_name: this.auth.user.first_name,
            last_name: this.auth.user.last_name,
            gender: this.findMetaString('gender'),
            return_to_work: this.findMetaBoolean('return_to_work'),
            return_to_education: this.findMetaBoolean('return_to_education'),
            return_to_unsure: this.findMetaBoolean('return_to_unsure'),
            phone: this.findMetaString('phone'),
            age: this.findMetaString('age'),
            contract_types: this.findMetaValue('contract_types'),
            industry_goals: this.findMetaValue('industry_goals'),
            industry_experience: this.findMetaValue('industry_experience'),
        }),

        updatePasswordErrors: {
          updatepassword: null,
        },
        updatePasswordForm: this.$inertia.form({
            updatepassword: null
        }),

        updateEmailErrors: {
            email: null,
        },
        updateEmailForm: this.$inertia.form({
            email: this.auth.user.email,
        }),

        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        passwordRules: [
          (value) => !!value || 'Please type a password.',
          (value) => (value && value.length >= 6) || 'minimum 6 characters',
        ],
    }
  },
  computed: {
    passwordMatch() {
      return () => this.password === this.verify || "Password must match";
    },
    
  },
  mounted() {
    if (this.$page.props.flash.flasher == 'verify')
                {
                    if (this.$page.props.flash.success)
                    {
                        this.verify_msg = this.$page.props.flash.success;
                        this.verify_msg_type= 'success';
                    }
                    else
                    {     
                        this.verify_msg = this.$page.props.flash.error;
                        this.verify_msg_type = 'error';
                    }
                }
                else
                    this.verify_msg_type =  "error";
  },
  created() {
    //this.editPersonalInfo = JSON.parse(JSON.stringify(this.auth.user));
  },
  watch: {
      
    },
  methods: {
    deleteUser() {
        axios.post("/deleteuser").then((response) => {
            window.location.href = String(this.baseurl);
        });
    },
    findMetaString(key) {
        let m = this.usermeta.filter(m=>m.meta_key==key)
        if (m.length == 1)
            return m[0].meta_value;
        else
            return ""
    },
    findMetaBoolean(key) {
        let m = this.usermeta.filter(m=>m.meta_key==key)
        if (m.length == 1)
            return true;
        else
            return false
    },
    findMetaValue(key) {

        let m = this.usermeta.filter(m=>m.meta_key==key)
        console.log('finding meta value for '+key,m)
        if (m.length == 1)
            return [m[0].meta_value];
        else
        {
            let a = [];
            for(var i=0;i<m.length;i++)
            {
                if (/^-?\d+$/.test(m[i].meta_value))
                    a.push(parseInt(m[i].meta_value))
                else
                    a.push(m[i].meta_value)
            }
            console.log('usermeta for key '+key,a)
            return a;
        }
    },
    isUser() {
        if (this.auth.user.roles.includes('user'))
            return true;
        else
            return false;
    },
    resendVerification() {
        let f = this.$inertia.form({});
        this.verify_loading = true;
        f.post('/email/verification-notification', {
            onSuccess: (res) => {
                this.verify_loading = false;
                if (this.$page.props.flash.flasher == 'verify')
                {
                    if (this.$page.props.flash.success)
                    {
                        this.verify_msg = this.$page.props.flash.success;
                        this.verify_msg_type= 'success';
                    }
                    else
                    {     
                        this.verify_msg = this.$page.props.flash.error;
                        this.verify_msg_type = 'error';
                    }
                }
                else
                    this.verify_msg_type =  "error";
                console.log('success on resendVerification',res)
            },
            onError: (res) => {
                console.log('got error on resendVerification',res)
            },
        });
    },
    savePassword() {
        console.log('changed password?')
        this.updatePasswordErrors.updatepassword = ''
        this.updatePasswordForm.post('/users/profile/updatePassword', {
            onSuccess: (res) => {
            console.log('success on updatePassword',res)
            },
            onError: (res) => {
                console.log('got error on updatePassword',res)
                this.updatePasswordErrors.updatepassword = (res && res.updatepassword) ? res.updatepassword : ''
            },
        })
    },
    saveEmail() {
        console.log('changed email');
        this.updateEmailErrors.email = ''
        this.updateEmailForm.post('/users/profile/updateEmail', {
            onSuccess: (res) => {
            console.log('success on updateEmail',res)
            },
            onError: (res) => {
                console.log('got error on email',res)
                this.updateEmailErrors.email = (res && res.email) ? res.email : ''
            },
        })
        console.log('changed email done?');
    },
    saveProfile() {
      console.log('saveProfile',this.editPersonalInfo)
      this.editPersonalInfoErrors.first_name = ''
      this.editPersonalInfoErrors.last_name = ''

      console.log('editPersonalInfo',this.editPersonalInfo)
      this.editPersonalInfo.post('/users/profile/update', {
        onSuccess: (res) => {
        console.log('success on update profile',res)
        },
        onError: (res) => {
            console.log('profile save error:',res)
            this.editPersonalInfoErrors.first_name = (res && res.first_name) ? res.first_name : ''
            this.editPersonalInfoErrors.last_name = (res && res.last_name) ? res.last_name : ''
        },
      })
    },
    
    getErrors(s) {
      if (this.errors)
        console.log('get errors',s,this.errors,this.errors[s])
        if (this.errors && this.errors[s])
            return this.errors[s]
        else
            return ""
    }
  }

  /*<v-col
                                cols="12"
                                sm="12"
                                md="6"
                                >
                                <v-text-field validate-on-blur :rules="emailRules" v-model="editPersonalInfo.updateemail" :error-messages="editPersonalInfoErrors.updateemail" label="Email" type="email" required="true"></v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                >
                                <v-text-field validate-on-blur :rules="passwordRules" v-model="editPersonalInfo.updatepassword" :error-messages="editPersonalInfoErrors.updatepassword" label="Password" type="Password" required="true"></v-text-field>
                            </v-col>*/
  
}
</script>
